import { type RecommendationConfig } from '../../../shared/types';
import { TrackingCategory, TrackingListName } from '../../enums';
import { ProductSlider } from '../ProductSlider';

type ProductCategorySliderProps = {
    readonly virtualSlide?: boolean;
    readonly lazyLoad?: boolean;
    readonly config: RecommendationConfig;
};

const ProductCategorySlider = ({
    config,
    lazyLoad = false,
    virtualSlide,
}: ProductCategorySliderProps): JSX.Element | null => {
    const { initialState } = config;

    const categoryData = initialState?.categoryData;

    if (!categoryData) {
        return null;
    }

    return (
        <ProductSlider
            productItems={initialState.results ?? []}
            title={categoryData.label}
            urlTitle={categoryData.label}
            url={`/l/${categoryData.pageId}`}
            trackingCategory={TrackingCategory.ProductList}
            trackingListName={TrackingListName.Category}
            dataTestId="category-slider"
            lazyLoad={lazyLoad}
            virtualSlide={virtualSlide}
        />
    );
};

export { ProductCategorySlider };
